import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        display: block;
        font-family: var(--sgdf-font-sans);
    }

    .participant-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        grid-gap: 1rem;
    }

    .invalid {
        color: red;
        font-weight: bold;
    }
    .sort-line {
        display: flex;
        flex-direction: horizontal;
        align-items: center;
        column-gap: var(--sgdf-spacing-medium);
        padding: var(--sgdf-spacing-small);
        border: 1px solid var(--sgdf-color-light);
        border-radius: var(--sgdf-border-radius-medium);
        margin-bottom: var(--sgdf-spacing-small);
        background-color: var(--sgdf-color-gray-50);
    }
    .arrow-rotate {
        transform: rotate(90deg);
    }
`;
//# sourceMappingURL=participant-list.styles.js.map